import React from 'react';
import './Listings.css';

const Listings = () => {
  return (
    <div className="listings-page page-container">

      {/* ── Hero ── */}
      <section className="listings-hero">
        <span className="section-eyebrow">Explore Properties</span>
        <h1 className="listings-hero-title">
          Premium Properties on <span className="amber-text">ECR &amp; OMR</span>
        </h1>
        <p className="listings-hero-sub" style={{ marginBottom: '1rem' }}>
          We are currently updating our portfolio with exclusive, legally verified plots and farm lands. 
          Please check back soon or contact us directly for our offline premium listings.
        </p>
        <a href="/contact" className="cta-button cta-pulse" style={{ display: 'inline-flex', marginTop: '1rem' }}>
          <i className="fas fa-phone-alt" /> Contact Our Experts
        </a>
      </section>

    </div>
  );
};

export default Listings;